import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { getIn } from "formik";
import DeleteIcon from '@mui/icons-material/Delete';
import NumberFormatText from '../../common/form/NumberFormatText';

const ProductForm = ({ formik, index, product, handleRemove }) => {


    const productCnt = `prdtList[${index}].productCnt`;
    const touchedProductCnt = getIn(formik.touched, productCnt);
    const errorProductCnt = getIn(formik.errors, productCnt);

    const priceVal = `prdtList[${index}].priceVal`;
    const touchedPriceVal = getIn(formik.touched, priceVal);
    const errorPriceVal = getIn(formik.errors, priceVal);



    return (
        <TableRow key={index}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{product?.partnerNm}</TableCell>
            <TableCell>{product?.pricePartnerNm}</TableCell>
            <TableCell>{product?.productNm}</TableCell>
            <TableCell>{product?.modelNm}</TableCell>

            <TableCell sx={{ width: '80px' }}>
                <TextField
                    size="small"
                    required
                    variant="standard"
                    fullWidth
                    name={productCnt}
                    id={productCnt}
                    value={formik.values.prdtList[index].productCnt}
                    helperText={
                        touchedProductCnt && errorProductCnt
                            ? errorProductCnt
                            : ""
                    }
                    error={Boolean(touchedProductCnt && errorProductCnt)}
                    onChange={(e) =>
                        formik.setFieldValue(productCnt, e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    InputProps={{
                        inputComponent: NumberFormatText,
                    }}
                />
            </TableCell>
            <TableCell sx={{ width: '180px' }}>
                <TextField
                    size="small"
                    required
                    variant="standard"
                    fullWidth
                    name={priceVal}
                    id={priceVal}
                    value={formik.values.prdtList[index].priceVal}
                    helperText={
                        touchedPriceVal && errorPriceVal
                            ? errorPriceVal
                            : ""
                    }
                    error={Boolean(touchedPriceVal && errorPriceVal)}
                    onChange={(e) =>
                        formik.setFieldValue(priceVal, e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    InputProps={{
                        inputComponent: NumberFormatText,
                    }}
                />
            </TableCell>
            <TableCell>
                <IconButton aria-label="delete" onClick={handleRemove}><DeleteIcon /></IconButton>
            </TableCell>
        </TableRow>
    )
}

export default ProductForm